import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const VolunteerSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container
      maxWidth={false}
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `url('https://storage.googleapis.com/genibot2.appspot.com/images/ZV4qJzg5hbFPZR5MPnMH.png?uid=7bc0f60d-bb20-4ef9-a737-19bb551b7c1d') center/cover no-repeat`,
        position: 'relative',
      }}
    >
      {/* Sunlight Overlay */}
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          background: 'rgba(255, 255, 255, 0.7)', // Light overlay for readability
          backdropFilter: 'blur(1px)', // Softens the background
        }}
      />

      {/* Glassy Content Box */}
      <Box
        sx={{
          position: 'relative',
          textAlign: 'center',
          color: '#5D4037', // Warm brownish text for elegance
          p: 5,
          borderRadius: 3,
          maxWidth: 700,
          backdropFilter: 'blur(10px)',
          background: 'rgba(255, 245, 210, 0.7)', // Soft golden glass effect
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
        }}
      >
        <Box sx={{ mb: 2 }}>
          <img src="/images/volunteer_success.png" alt="Success Icon" style={{ width: 90, height: 90 }} />
        </Box>

        <Typography
          variant="h4"
          gutterBottom
          sx={{ fontWeight: 'bold', letterSpacing: 1, color: '#6D4C41' }}
        >
          🤝 Thank You for Volunteering!
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, fontSize: '1.2rem', color: '#5D4037' }}>
          Your commitment to **Hope Beyond International** is truly inspiring!  
          You are now part of a community dedicated to **compassionate service** and **meaningful impact**.  
          Our team will **contact you soon** with further details.
        </Typography>

        <Typography
          variant="body2"
          sx={{ mb: 4, fontSize: '1rem', fontStyle: 'italic', opacity: 0.85, color: '#795548' }}
        >
          Together, we are changing lives. Thank you for your kindness and dedication! 🌟
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
            variant="contained"
            sx={{
              px: 3,
              py: 1,
              fontSize: '1rem',
              borderRadius: 2,
              backgroundColor: '#6D4C41', // Brown color matching the Donate button
              color: '#fff',
              '&:hover': { backgroundColor: '#5D4037' }, // Darker brown on hover
            }}
            onClick={() => navigate('/')}
          >
            Return Home
          </Button>
          <Button
            variant="outlined"
            sx={{
              px: 3,
              py: 1,
              fontSize: '1rem',
              borderRadius: 2,
              color: '#6D4C41',
              borderColor: '#6D4C41',
              '&:hover': { backgroundColor: 'rgba(93, 64, 55, 0.1)' },
            }}
            onClick={() => navigate('/volunteer')}
          >
            Explore More
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default VolunteerSuccess;
